export default __webpack_public_path__ + "static/media/symbol-black.5af83be2.svg";